import React, { useEffect, useState } from "react";
import { useBuilding } from "../../context/BuildingContext";
import { reportsApi } from "../../services/api";
import GenericReportViewer from "./GenericReportViewer";

interface Props {
  period: string;
}

const SpendingCategoriesReport: React.FC<Props> = ({ period }) => {
  const { currentBuilding } = useBuilding();
  const [comparePrior, setComparePrior] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [report, setReport] = useState<any>(null);

  useEffect(() => {
    if (!currentBuilding?.id) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await reportsApi.getSpendingCategories(
          currentBuilding.id,
          {
            period,
            comparePrior,
          },
        );
        if (!cancelled) setReport(data);
      } catch (e) {
        console.error(e);
        if (!cancelled) setError("Failed to load spending categories.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [currentBuilding?.id, period, comparePrior]);

  return (
    <div>
      <div className="bg-white shadow rounded-lg p-4 mb-4">
        <label className="inline-flex items-center text-sm">
          <input
            type="checkbox"
            className="mr-2"
            checked={comparePrior}
            onChange={(e) => setComparePrior(e.target.checked)}
          />
          Compare prior period
        </label>
      </div>
      <GenericReportViewer
        title="Spending Categories"
        loading={loading}
        error={error}
        report={report}
      />
    </div>
  );
};

export default SpendingCategoriesReport;
